export default __webpack_public_path__ + "static/media/logo-svan.bb2dc984.svg";